import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgLogoConnecteed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="logo_connecteed_svg__Calque_1"
    data-name="Calque 1"
    viewBox="0 0 1228.02 163.37"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <style>{".logo_connecteed_svg__cls-1{fill:#6058f7}"}</style>
    </defs>
    <g id="logo_connecteed_svg__Groupe_25" data-name="Groupe 25">
      <path
        id="logo_connecteed_svg__Trac\xE9_35"
        d="M435.11 42.36a37.92 37.92 0 0 1 29.01 13.13 45.4 45.4 0 0 1 12.01 31.75v56.52h-23.14V86.29a18.8 18.8 0 0 0-5-13.14c-3-3.5-7.39-5.5-12.01-5.47h-16.26c-4.61-.03-9 1.97-12.01 5.47-3.31 3.57-5.1 8.27-5.01 13.14v57.47h-23.13V87.25a45.4 45.4 0 0 1 12.01-31.75 37.89 37.89 0 0 1 29.01-13.13h14.51Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 35"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_26" data-name="Groupe 26">
      <path
        id="logo_connecteed_svg__Trac\xE9_36"
        d="M544.16 42.36a37.92 37.92 0 0 1 29.01 13.13 45.4 45.4 0 0 1 12.01 31.75v56.52h-23.14V86.29a18.8 18.8 0 0 0-5-13.14c-3-3.5-7.39-5.5-12.01-5.47h-16.26c-4.61-.03-9 1.97-12.01 5.47-3.31 3.57-5.1 8.27-5.01 13.14v57.47h-23.13V87.25a45.4 45.4 0 0 1 12.01-31.75 37.89 37.89 0 0 1 29.01-13.13h14.51Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 36"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_27" data-name="Groupe 27">
      <path
        id="logo_connecteed_svg__Trac\xE9_37"
        d="M687.35 57.14c5.47 6.6 8.98 14.61 10.13 23.11.33 2.27.5 4.55.5 6.84v11.64c0 .91-.04 1.78-.13 2.6h-76.9c.35 4.57 2.29 8.88 5.5 12.16a15.47 15.47 0 0 0 11.4 4.79h20.01c5.92-.09 11.35-3.32 14.25-8.48h24.63a45.95 45.95 0 0 1-9.37 19 39.88 39.88 0 0 1-30.39 14.78h-18.26a37.5 37.5 0 0 1-28.02-12.04 46.63 46.63 0 0 1-12.88-30.24c-.09-.86-.13-1.73-.13-2.6V87.1c0-2.29.17-4.58.51-6.85a46.63 46.63 0 0 1 13.88-27.16c7.09-7 16.68-10.86 26.64-10.74h18.26c11.84.1 23 5.54 30.39 14.79M621.7 80.25h52.27c-.64-1.95-1.57-3.79-2.75-5.47a16.47 16.47 0 0 0-13.38-7.12h-20.01c-7.51 0-12.89 4.2-16.15 12.59"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 37"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_28" data-name="Groupe 28">
      <path
        id="logo_connecteed_svg__Trac\xE9_38"
        d="M234.6 105.39c-.84 2.41-2.17 4.61-3.9 6.48-3 3.51-7.39 5.52-12.01 5.49h-20.13a15.66 15.66 0 0 1-12.01-5.49c-3.31-3.56-5.1-8.27-5.01-13.13V85.19a18.8 18.8 0 0 1 5.01-13.14c3-3.5 7.39-5.5 12.01-5.47h20.13c4.61-.03 9 1.97 12.01 5.47a18.7 18.7 0 0 1 4.08 7.02h23.59a44.57 44.57 0 0 0-11.54-24.7 37.89 37.89 0 0 0-29.01-13.13h-18.38a37.92 37.92 0 0 0-29.01 13.13 45.46 45.46 0 0 0-12.01 31.77v11.63a45.37 45.37 0 0 0 12.01 31.74 37.9 37.9 0 0 0 29.01 13.14h18.38c11.13.09 21.74-4.71 29.01-13.14 6.2-6.68 10.2-15.11 11.46-24.14H234.6Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 38"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_29" data-name="Groupe 29">
      <path
        id="logo_connecteed_svg__Trac\xE9_39"
        d="M291.34 78.84c.84-2.41 2.17-4.61 3.9-6.48 3-3.5 7.39-5.5 12.01-5.47h20.13c4.61-.03 9 1.97 12.01 5.47 3.3 3.57 5.09 8.27 4.99 13.13v13.55c.1 4.86-1.69 9.57-4.99 13.14-3.01 3.5-7.4 5.5-12.01 5.47h-20.13c-4.61.03-9-1.97-12.01-5.47a18.7 18.7 0 0 1-4.06-7.02h-23.62a44.57 44.57 0 0 0 11.54 24.7 37.89 37.89 0 0 0 29.01 13.13h18.38c11.13.09 21.74-4.71 29.01-13.13a45.44 45.44 0 0 0 12.01-31.74V86.47a45.4 45.4 0 0 0-12.01-31.74 37.9 37.9 0 0 0-29.01-13.15h-18.38a37.9 37.9 0 0 0-29.01 13.15c-6.2 6.68-10.2 15.1-11.46 24.13h23.69Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 39"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_30" data-name="Groupe 30">
      <path
        id="logo_connecteed_svg__Trac\xE9_40"
        d="M781.95 105.87c-.84 2.41-2.17 4.61-3.9 6.48-3 3.51-7.39 5.52-12.01 5.49h-20.13a15.66 15.66 0 0 1-12.01-5.49c-3.31-3.56-5.1-8.27-5.01-13.13V85.67a18.8 18.8 0 0 1 5.01-13.14c3-3.5 7.39-5.5 12.01-5.47h20.13c4.61-.03 9 1.97 12.01 5.47a18.7 18.7 0 0 1 4.08 7.02h23.59a44.57 44.57 0 0 0-11.54-24.7 37.89 37.89 0 0 0-29.01-13.13h-18.38a37.92 37.92 0 0 0-29.01 13.13 45.46 45.46 0 0 0-12.01 31.77v11.63a45.37 45.37 0 0 0 12.01 31.74 37.9 37.9 0 0 0 29.01 13.14h18.38c11.13.09 21.74-4.71 29.01-13.14 6.2-6.68 10.2-15.11 11.46-24.14h-23.69Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 40"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_31" data-name="Groupe 31">
      <path
        id="logo_connecteed_svg__Trac\xE9_41"
        d="M835.58 99.74c-1.04 4.56-.14 9.35 2.5 13.21 2.46 3.55 6.57 5.6 10.89 5.42h17.65l-4.59 24.4-.08.4-.09.47h-16.89a31.64 31.64 0 0 1-19.5-6.06 33.3 33.3 0 0 1-11.64-16.21 44.16 44.16 0 0 1-1.25-22.58L831.83 0h23.14l-9.13 46.65a43.1 43.1 0 0 1 18.76-4.39h16.37l-4.77 25.31h-17.35c-4.85.06-9.48 1.98-12.97 5.35-3.91 3.49-6.6 8.13-7.67 13.26l-2.63 13.54Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 41"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_32" data-name="Groupe 32">
      <path
        id="logo_connecteed_svg__Trac\xE9_42"
        d="M980.8 57.06a31.4 31.4 0 0 0-27.39-14.79h-18.17a44.77 44.77 0 0 0-28.64 10.76 58.8 58.8 0 0 0-13.03 14.56 61.5 61.5 0 0 0-6.04 12.59c-.74 2.25-1.37 4.53-1.87 6.84l-2.25 11.63c-.16.91-.29 1.77-.37 2.6a39.57 39.57 0 0 0 7.04 30.24c6 7.95 15.52 12.44 25.47 12.03h18.3c12.53-.48 24.4-5.77 33.13-14.77a59.3 59.3 0 0 0 12.95-19h-24.52a20.78 20.78 0 0 1-15.82 8.47h-19.95c-4.05.17-7.93-1.61-10.45-4.79a16.1 16.1 0 0 1-3.12-12.17h76.73c.16-.83.32-1.69.47-2.6l2.24-11.63c.51-2.25.81-4.54.89-6.85.62-8.1-1.34-16.19-5.6-23.11m-69.86 23.11c4.9-8.38 11.08-12.58 18.55-12.59h19.92c5.02-.12 9.67 2.66 11.94 7.13.86 1.71 1.41 3.56 1.63 5.46h-52.05Z"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 42"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_33" data-name="Groupe 33">
      <path
        id="logo_connecteed_svg__Trac\xE9_43"
        d="M1093.58 57.06c4.28 6.91 6.25 15 5.63 23.11-.09 2.31-.38 4.6-.87 6.85l-2.25 11.63c-.17.91-.33 1.78-.5 2.6h-77.04c-.66 4.32.47 8.71 3.12 12.18 2.54 3.18 6.44 4.95 10.51 4.79h20.01a20.94 20.94 0 0 0 15.88-8.48h24.64a59.6 59.6 0 0 1-13.01 19c-8.78 9-20.68 14.29-33.24 14.77h-18.38c-9.98.41-19.53-4.09-25.57-12.03a39.58 39.58 0 0 1-7.09-30.22c.09-.82.21-1.69.38-2.6l2.25-11.63c.51-2.31 1.14-4.59 1.88-6.84a59.3 59.3 0 0 1 19.13-27.16 45.1 45.1 0 0 1 28.77-10.74h18.27a31.52 31.52 0 0 1 27.49 14.78m-70.16 23.1h52.27c-.22-1.9-.77-3.76-1.63-5.47-2.3-4.49-6.97-7.26-12.01-7.12h-20.01c-7.51 0-13.72 4.2-18.63 12.59"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 43"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_34" data-name="Groupe 34">
      <path
        id="logo_connecteed_svg__Trac\xE9_44"
        d="M1193.62 58.42 1204.89 0h23.12l-19.13 98.65a58.95 58.95 0 0 1-18.38 31.95 45.6 45.6 0 0 1-31.26 12.93h-21.63c-9.55.43-18.66-4.06-24.14-11.9a37.74 37.74 0 0 1-5.5-29.42l3.62-18.75a53.52 53.52 0 0 1 16.95-29.35 42.32 42.32 0 0 1 28.82-11.84h9.38a29.5 29.5 0 0 1 16.07 4.38 30.3 30.3 0 0 1 10.82 11.76m-8.01 41.2 2.63-13.54c.96-4.54.03-9.27-2.56-13.12a12.53 12.53 0 0 0-10.81-5.36h-20.01c-4.86.05-9.52 1.97-13.01 5.36a24.7 24.7 0 0 0-7.63 13.14l-2.63 13.54c-1.06 4.58-.15 9.39 2.5 13.27 2.49 3.51 6.58 5.52 10.88 5.34H1165a19.04 19.04 0 0 0 12.95-5.34c3.91-3.5 6.6-8.16 7.67-13.29"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 44"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_35" data-name="Groupe 35">
      <path
        id="logo_connecteed_svg__Trac\xE9_45"
        d="m129.35 119.03-13.3-14.58a17.52 17.52 0 0 0-20.81-4.16L57.2 58.68a21.88 21.88 0 0 0-3.8-22.76L40.1 21.34c-6.42-7.28-17.52-7.98-24.8-1.56q-.825.735-1.56 1.56l-7.66 8.37c-7.25 8.25-7.25 20.59 0 28.84l13.3 14.58a17.52 17.52 0 0 0 20.81 4.16l38.04 41.61a21.88 21.88 0 0 0 3.8 22.76l13.33 14.58c6.42 7.28 17.52 7.97 24.8 1.55.55-.48 1.07-1 1.55-1.55l7.63-8.38c7.25-8.25 7.25-20.59 0-28.84"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 45"
      />
    </g>
    <g id="logo_connecteed_svg__Groupe_36" data-name="Groupe 36">
      <path
        id="logo_connecteed_svg__Trac\xE9_46"
        d="M94.71 22.53 81.39 37.1a21.88 21.88 0 0 0-3.8 22.76l-38.04 41.61a17.5 17.5 0 0 0-20.8 4.16L5.43 120.21c-7.25 8.25-7.25 20.59 0 28.84l7.66 8.38c6.42 7.28 17.52 7.98 24.8 1.56q.825-.735 1.56-1.56l13.3-14.58a21.88 21.88 0 0 0 3.8-22.76l38.03-41.61a17.52 17.52 0 0 0 20.81-4.16l13.3-14.58c7.25-8.25 7.25-20.59 0-28.84l-7.61-8.37c-6.42-7.28-17.52-7.98-24.8-1.56q-.825.735-1.56 1.56"
        className="logo_connecteed_svg__cls-1"
        data-name="Trac\xE9 46"
      />
    </g>
  </svg>
);
const Memo = memo(SvgLogoConnecteed);
export default Memo;
